import { useMemo } from 'react'

import { IntegrationServices } from '@sequencehq/api'

import { useLoadLedgerIntegrations } from 'Integrations/index'
import { Customer } from 'Invoices/types'

export type CustomerLedgerIntegration = {
  id: IntegrationServices
  defaultLedgerAccount: string | undefined
  options: Array<{ id: string; name: string; code: string }>
}

export const useCustomerLedgerIntegrations = ({
  customerIntegrationIds
}: {
  customerIntegrationIds?: Customer['integrationIds']
}): CustomerLedgerIntegration[] => {
  const integrationsLoader = useLoadLedgerIntegrations({
    integrationIds: customerIntegrationIds
  })

  const customerLedgerIntegrations = useMemo(() => {
    if (
      !customerIntegrationIds ||
      integrationsLoader.loading ||
      integrationsLoader.hasError
    ) {
      return []
    }

    const customerExternalIdsKeys = customerIntegrationIds.map(
      ({ service }) => service
    )

    const customerLedgerIntegrations = (
      integrationsLoader.data?.ledgerIntegrations ?? []
    ).filter(integration => customerExternalIdsKeys.includes(integration.key))

    return customerLedgerIntegrations.map(
      ({ key, value, defaultLedgerAccount }) => ({
        id: key,
        defaultLedgerAccount,
        options: value
      })
    )
  }, [customerIntegrationIds, integrationsLoader])

  return customerLedgerIntegrations
}
